<template>
	<CardLarge class="center">
		<header>{{ header }}</header>
		<ul>
			<Party v-for="item in results" :key="item.partyId" :item="item" />
		</ul>
	</CardLarge>
</template>

<script>
import { mapState } from 'vuex'
import Party from '@/components/Results/List/Party'
import CardLarge from '@/components/Layout/CardLarge.vue'

import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollToPlugin)

export default {
	name: 'ListView',

	components: {
		Party,
		CardLarge
	},

	computed: {
		...mapState({
            header: (state) => state.dictionary.general.list.header,
			results: (state) => state.results
		})
	},

	mounted() {
		gsap.set(window, { scrollTo: { y: 0 } })
	}
}
</script>

<style lang="scss" scoped>
.card {
	margin-bottom: 60px;
}

header {
	color: $blue;
	margin: 0 auto;
	text-align: center;
	font-weight: bold;
	@include type-large();

	@include media('<=phone') {
		padding: 20px 0 30px;
	}

	@include media('>phone') {
		max-width: 430px;
		padding-bottom: 30px;
	}
}
</style>
